import React from 'react';
import { useRecordContext, useTranslate } from 'react-admin';
import { green, red } from '@mui/material/colors';

import ChipField from '../../common/fields/ChipField';


const StatusField = ({ source = 'status', size = 'small', ...props }) => {
	const record = useRecordContext();
	const translate = useTranslate();

	const statuses = {
		'new': translate('New'),
		'accepted': translate('Accepted'),
		'refused': translate('Refused')
	};

	if(!record) {
		return null;
	}
	const status = record[source];
	let sx = {};
	switch (status) {
		case 'accepted':
			sx = { backgroundColor: (theme) => theme.palette.mode === 'dark' ? green[700] : green[200] };
			break;
		case 'refused':
			sx = { backgroundColor: (theme) => theme.palette.mode === 'dark' ? red[700] : red[200] };
			break;
		default:
			break;
	}

	if (!status) {
		return null;
	}

	return (
		<ChipField source={status} record={statuses} sx={sx} size={size} {...props} />
	);
};

export default StatusField;
